import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider, useDispatch } from 'react-redux';
import './scss/orgResults.scss';

import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import OrgResultsReducers from './reducers/orgResults.reducer';
import OrgResultsComp from './containers/orgResults.container';
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n';

let store: any;

function renderOrgResultsPage(data :any) {
  let initialState = {
    ...data,
    userList: null,
    defaultUserList: null
  }
  store = createStore(OrgResultsReducers, initialState, applyMiddleware(thunk));
  const mountId = document.getElementById('render-goal-org-results');
  if (mountId) {
    ReactDOM.render(
      <Provider store={store}>
        <Suspense fallback="loading...">
          <I18nextProvider i18n={i18n}>
            <OrgResultsComp />
          </I18nextProvider>
        </Suspense>,
      </Provider>,
      mountId
    );
  }
}

window.renderOrgResultsPage = renderOrgResultsPage;
